import React from "react";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { FiYoutube } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import ME from "../../assets/avatars/me.png";

const HeaderSocials = () => {
  return (
    <>
      <div className="header__socials_left">
        <a
          href="https://www.linkedin.com/in/enderson-millan"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin className="header__socials_link" />
        </a>
        <a
          href="https://github.com/ENDERSON-MARIN"
          target="_blank"
          rel="noreferrer"
        >
          <BsGithub className="header__socials_link" />
        </a>
        <a
          href="https://www.youtube.com/@millanendersondev"
          target="_blank"
          rel="noreferrer"
        >
          <FiYoutube className="header__socials_link" />
        </a>
      </div>
      <div className="me">
        <img src={ME || "/placeholder.svg"} alt="me" />
      </div>
      <div className="header__socials_right">
        <a
          href="https://facebook.com/enderson.marin.9"
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebookF className="header__socials_link" />
        </a>
        <a
          href="https://instagram.com/marinenderson"
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram className="header__socials_link" />
        </a>
        <a
          href="https://www.tiktok.com/@endersondev"
          target="_blank"
          rel="noreferrer"
        >
          <FaTiktok className="header__socials_link" />
        </a>
      </div>
    </>
  );
};

export default HeaderSocials;
